import React, { useState, useEffect } from "react";
import { BASE_URL } from "./axios";
import axios from "axios";
import { AddwithWhiteCircle, DropdownArrow, SearchBig, UpdatePencil, PDFIcon, DeleteDustbin, Attachment, Eye, Documentation } from "../../utils/ReusableSVGs";
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import { ViewEmployeeList } from "../../utils/ReusableFunctions";
import { useNavigate } from "react-router-dom";

import { handleErrorToast } from "../../utils/ReusableFunctions";
import { toast, ToastContainer } from 'react-toastify';
import { StructureFlyovertable } from "./StructureTable";
import { Alltask } from "./AllTask"
import { AddActivity, EditDepartment, DepartmentDelete, AddTask, AddSubActivity, SubActivityModal, UpdateTask, DeleteTask } from "./AllProjectdetailsmodal";



const AllTask = ({ projectID, TaskData, getDepartmentList, departmentlist, getTaskList, tasklist, department_name }) => {
    const [toggleStatechange, setToggleStatechange] = useState(1);
    const [clientExists, setClientExists] = useState(false);
    const [allTaskData, setAllTaskData] = useState([]);
    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    // Group tasks with their sub-tasks
    const groupedTasks = () => {
        const groups = {};

        // First find all main tasks (those without parent)
        const mainTasks = allTaskData.filter(task => !task.task_parent);

        // Then find all sub-tasks (those with parent)
        const subTasks = allTaskData.filter(task => task.task_parent);

        // Organize the data
        mainTasks.forEach(task => {
            // Check if this task has any sub-tasks in the subTasks array
            const relatedSubTasks = subTasks.filter(
                sub => sub.task_parent === task.id
            );

            groups[task.id] = {
                main: task,
                sub: relatedSubTasks.length > 0 ? relatedSubTasks : null,
                showAsMain: relatedSubTasks.length === 0 // Flag to show as regular row if no sub-tasks
            };
        });

        return groups;
    };

    const ViewTaskActivities = (projectID, Task) => {
        navigate(`/${urlParts[3]}/projectTaskActivities/`, {
            state: { projectID, Task },
        });
    };

    // Load task data
    useEffect(() => {
        if (TaskData) {
            // If TaskData is provided, use it directly
            setAllTaskData([TaskData]);
        } else {
            // Otherwise fetch all tasks (you might need to implement this)
            // fetchAllTasks();
        }
    }, [TaskData]);

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false}
                newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            <div className="attendance-box">
                <div className="info-box-div-without-bg">
                    <div className="personal-detail" style={{ width: '100%' }}>
                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                            <table className="table-css" style={{ minWidth: '1000px' }}>
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text">S. No</th>
                                        <th className="table-heading-text">Task Name</th>
                                        <th className="table-heading-text">Assigned To</th>
                                        <th className="table-heading-text">Priority</th>
                                        <th className="table-heading-text">Status</th>
                                        <th className="table-heading-text">Start Date</th>
                                        <th className="table-heading-text">Deadline</th>
                                        <th className="table-heading-text">Documentation</th>
                                        <th className="table-heading-text">View Activities</th>
                                        <th className="table-heading-text">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(groupedTasks()).map(([parentId, group], groupIndex) => {
                                        // If task has no sub-tasks, show as regular row
                                        if (group.showAsMain) {
                                            return (
                                                <tr key={group.main.id} className="custom-table-head-td">
                                                    <td className="table-body">{groupIndex + 1}</td>
                                                    <td className="table-body">
                                                        {group.main.task_name || '-'}
                                                    </td>
                                                    <td className="table-body">
                                                        {group.main.assigned_to?.join(', ') || '-'}
                                                    </td>
                                                    <td className="table-body">
                                                        <span className={`priority-${group.main.priority?.toLowerCase()}`}>
                                                            {group.main.priority || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="table-body">
                                                        <span className={`status-${group.main.status?.toLowerCase()}`}>
                                                            {group.main.status || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="table-body">{formatDate(group.main.assigned_date)}</td>
                                                    <td className="table-body">{formatDate(group.main.deadline_date)}</td>
                                                    <td className="table-body">
                                                        {group.main.uploaded_file ? (
                                                            <a href={group.main.uploaded_file} target="_blank" rel="noopener noreferrer">
                                                                <Documentation />
                                                            </a>
                                                        ) : '-'}
                                                    </td>
                                                    <td className="table-body">
                                                        <button
                                                            onClick={() => ViewTaskActivities(projectID, group.main)}
                                                            title="View Activities"
                                                            className="action-button"
                                                        >
                                                            <Eye />
                                                        </button>
                                                    </td>
                                                    <td className="table-body">
                                                        <div className="flex-row">
                                                            <UpdateTask
                                                                i={group.main}
                                                                projectID={projectID}
                                                                getTaskList={getTaskList}
                                                                tasklist={tasklist}
                                                                department_name={department_name}
                                                            />
                                                            <DeleteTask
                                                                i={group.main}
                                                                projectID={projectID}
                                                                getTaskList={getTaskList}
                                                                tasklist={tasklist}
                                                                department_name={department_name}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        // If task has sub-tasks, show hierarchical structure
                                        return (
                                            <React.Fragment key={parentId}>
                                                {/* Main Task Row */}
                                                <tr className="custom-table-head-td" style={{ backgroundColor: '#f5f5f5', fontWeight: '500' }}>
                                                    <td className="table-body">{groupIndex + 1}</td>
                                                    <td className="table-body" colSpan="8">
                                                        <span className="task-marker" style={{ color: 'blue' }}>■</span>
                                                        {group.main.task_name || 'Unnamed Task'}
                                                    </td>
                                                </tr>

                                                {/* Sub Tasks */}
                                                {group.sub.map((subTask, index) => (
                                                    <tr key={subTask.id} className="custom-table-head-td">
                                                        <td className="table-body" style={{ paddingLeft: '30px' }}>
                                                            {groupIndex + 1}.{index + 1}
                                                        </td>
                                                        <td className="table-body" style={{ paddingLeft: '30px' }}>
                                                            <span className="subtask-marker" style={{ color: 'green' }}>•</span>
                                                            {subTask.task_name || 'Unnamed Sub-task'}
                                                        </td>
                                                        <td className="table-body">{subTask.assigned_to?.join(', ') || '-'}</td>
                                                        <td className="table-body">
                                                            <span className={`priority-${subTask.priority?.toLowerCase()}`}>
                                                                {subTask.priority || '-'}
                                                            </span>
                                                        </td>
                                                        <td className="table-body">
                                                            <span className={`status-${subTask.status?.toLowerCase()}`}>
                                                                {subTask.status || '-'}
                                                            </span>
                                                        </td>
                                                        <td className="table-body">{formatDate(subTask.assigned_date)}</td>
                                                        <td className="table-body">{formatDate(subTask.deadline_date)}</td>
                                                        <td className="table-body">
                                                            {subTask.uploaded_file ? (
                                                                <a href={subTask.uploaded_file} target="_blank" rel="noopener noreferrer">
                                                                    <Documentation />
                                                                </a>
                                                            ) : '-'}
                                                        </td>
                                                        <td className="table-body">
                                                            <div className="flex-row">
                                                                <button
                                                                    onClick={() => ViewTaskActivities(projectID, subTask)}
                                                                    title="View Activities"
                                                                    className="action-button"
                                                                >
                                                                    <Eye />
                                                                </button>
                                                                <UpdateTask
                                                                    i={subTask}
                                                                    projectID={projectID}
                                                                    getTaskList={getTaskList}
                                                                    tasklist={tasklist}
                                                                    department_name={department_name}
                                                                />
                                                                <DeleteTask
                                                                    i={subTask}
                                                                    projectID={projectID}
                                                                    getTaskList={getTaskList}
                                                                    tasklist={tasklist}
                                                                    department_name={department_name}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllTask;
